module.exports = __webpack_public_path__ + "img/avatar.9bcde009.svg";